import { AfterViewInit, Component, OnInit } from '@angular/core';
declare function $(string:string): any;
@Component({
  selector: 'app-residential',
  templateUrl: './residential.component.html',
  styleUrls: ['./residential.component.scss']
})
export class ResidentialComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {


  }

  ngAfterViewInit(){
    $('img.lightbox').lightBox(); // Select all links with lightbox class

  }
}
